import { FC } from 'react';
import { Avatar, Button, Col, Row } from 'antd';
import { TbRefresh, TbWorldX } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { centerComponentInMiddleofView } from '@/utilities';

import Metadata from './meta';

const Offline: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <>
            <Metadata />
            <div
                style={{
                    height: '100%',
                    backgroundColor: token.colorBgContainer,
                    ...centerComponentInMiddleofView,
                    overflow: 'hidden',
                    backgroundImage: `radial-gradient(
                    circle at 0.125rem 0.125rem,
                    ${token.colorBorder} 0.125rem,
                    transparent 0
                    )`,
                    backgroundSize: '1.5rem 1.5rem',
                }}
            >
                <div
                    style={{
                        padding: '3rem 1.5rem',
                        backgroundColor: token.colorBgBase,
                        textAlign: 'center',
                        borderRadius: token.borderRadius * 1.5,
                        border: `1px solid ${token.colorBorder}`,
                        boxShadow: token.boxShadow,
                    }}
                >
                    <Avatar
                        shape='square'
                        icon={
                            <TbWorldX
                                size='67.5%'
                                style={{ verticalAlign: '-0.1rem', color: token.colorTextTertiary }}
                            />
                        }
                        size={16 * 2.5}
                        style={{
                            border: `1px solid ${token.colorBorder}`,
                            marginBottom: '0.25rem',
                            backgroundColor: token.colorBgContainer,
                        }}
                    />
                    <div style={{ margin: '0.5rem 0', color: token.colorTextSecondary, fontWeight: 500 }}>
                        You're Offline
                    </div>
                    <div style={{ width: '12.5rem', margin: '0 auto', textAlign: 'center' }}>
                        <small style={{ color: token.colorTextTertiary }}>
                            An internet connection is required to use Countercyclical.
                        </small>
                    </div>
                    <Row gutter={[8, 0]} wrap={false} align='middle' style={{ marginTop: '1rem' }}>
                        <Col flex='auto'>
                            <Button type='primary' onClick={() => window.location.reload()}>
                                <TbRefresh size='1rem' />
                                Retry Connection
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default Offline;
